import { EventTypes } from 'redux-segment';
import { canUseDOM } from '@surfline/web-common';

// All segment events should fire the same action.
export const SEGMENT_EVENT = 'SEGMENT_EVENT';

/**
 * Segment action used to identify a page event
 *
 * This action should typically get called from the constructor. Any meta
 * data required to fire the action can be passed through from the connected
 * route container.
 *
 * @param {Object} payload an object to send the event payload request.
 */
export const navigatedToPage = (name, properties = {}) => (dispatch) => {
  if (canUseDOM) {
    dispatch({
      type: SEGMENT_EVENT,
      meta: {
        analytics: {
          eventType: EventTypes.page,
          eventPayload: { name, properties },
        },
      },
    });
  }
};


/**
 * A common action meant to be triggered when a CTA is clicked. This is probably
 * best triggered from the `onClick` component hook.
 *
 * @param {String} ctaLocation location relative to the page that the CTA is rendered
 * @param {String} pageName the name of the page containing the CTA
 */
export const clickedOnboardingCTA = properties => async (dispatch) => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Onboarding CTA',
          properties: { ...properties },
        },
      },
    },
  });
};

export const clickedSubscribeCTA = properties => async (dispatch) => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Subscribe CTA',
          properties: { ...properties },
        },
      },
    },
  });
};

/**
 * Shared helper function for dispatching a segment event upon clicking a create
 * account CTA
 * @param {object} properties
 */
export const clickedCreateAccountCTA = properties => async (dispatch) => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Create Account',
          properties: { ...properties },
        },
      },
    },
  });
};

/**
 * A shared action meant to be triggered for homepage feed card actions. This is probably
 * best triggered from the `onClick` component hook.
 *
 * @param {String} name event name
 * @param {Object} properties properties for the corresponding event
 */
export const trackEvent = (name, properties) => async (dispatch) => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: name,
          properties: { ...properties },
        },
      },
    },
  });
};
